import React, { useState, useEffect } from 'react'

export default function LandingPage({ onEnterLogin }) {
  const [stretch, setStretch] = useState(0)

  useEffect(() => {
    let dir = 1
    const interval = setInterval(() => {
      setStretch(s => {
        let next = s + dir * 2
        if (next >= 100) dir = -1
        if (next <= 0) {
          dir = 1
          return 0
        }
        return next
      })
    }, 40)
    return () => clearInterval(interval)
  }, [])

  const fonts = {
    display: "'Cormorant Garamond', serif",
    body: "'Jost', sans-serif"
  }

  const colors = {
    bg: '#0a0e14',
    surface: '#11161f',
    gold: '#c9a84c',
    sage: '#7aab8a',
    rose: '#c47a7a',
    cream: '#f0ede6'
  }

  return (
    <div style={{
      background: colors.bg,
      color: colors.cream,
      fontFamily: fonts.body,
      minHeight: '100vh',
      overflowX: 'hidden'
    }}>

      {/* NAV */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '24px 32px',
        maxWidth: '1100px',
        margin: '0 auto'
      }}>
        <div style={{
          fontFamily: fonts.display,
          fontSize: '20px',
          color: colors.gold,
          letterSpacing: '0.5px'
        }}>
          ♀ Trade Like a Woman
        </div>
        <button
          onClick={onEnterLogin}
          style={{
            background: 'transparent',
            border: `1px solid ${colors.gold}`,
            color: colors.gold,
            padding: '8px 18px',
            borderRadius: '20px',
            fontSize: '12px',
            letterSpacing: '1px',
            fontFamily: fonts.body,
            cursor: 'pointer',
            textTransform: 'uppercase'
          }}>
          Member Login
        </button>
      </div>

      {/* HERO */}
      <div style={{
        maxWidth: '720px',
        margin: '60px auto 40px',
        padding: '0 24px',
        textAlign: 'center'
      }}>
        <div style={{
          fontSize: '11px',
          color: colors.sage,
          letterSpacing: '3px',
          textTransform: 'uppercase',
          marginBottom: '20px',
          fontFamily: fonts.body
        }}>
          Options Trading Education — For Women
        </div>

        <div style={{
          fontFamily: fonts.display,
          fontSize: 'clamp(34px, 6vw, 56px)',
          lineHeight: '1.1',
          marginBottom: '20px',
          color: colors.cream
        }}>
          Trade like a rubber band.<br/>
          <span style={{ color: colors.gold }}>
            Not a coin flip.
          </span>
        </div>

        <div style={{
          fontSize: '16px',
          color: 'rgba(240,237,230,0.6)',
          lineHeight: '1.8',
          maxWidth: '520px',
          margin: '0 auto 8px',
          fontFamily: fonts.body
        }}>
          Markets stretch and snap back.
          Learn to read the stretch —
          and get paid to wait for the return.
        </div>
      </div>

      {/* RUBBER BAND VISUAL */}
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '50px'
      }}>
        <svg width="320" height="200" viewBox="0 0 320 200">
          <line x1="40" y1="40" x2="280" y2="40"
            stroke="rgba(201,168,76,0.15)"
            strokeWidth="1" strokeDasharray="4,4" />
          <text x="160" y="28" textAnchor="middle"
            fill="rgba(240,237,230,0.3)"
            fontSize="9" fontFamily="monospace"
            letterSpacing="1">
            EQUILIBRIUM
          </text>

          <path
            d={`M 60 40 Q 160 ${40 + stretch * 1.1} 260 40`}
            fill="none"
            stroke={colors.gold}
            strokeWidth="3"
            strokeLinecap="round"
          />

          <circle cx="60" cy="40" r="5" fill={colors.gold} />
          <circle cx="260" cy="40" r="5" fill={colors.gold} />

          <circle
            cx="160"
            cy={40 + stretch * 1.1}
            r="6"
            fill={colors.sage}
          />

          {stretch > 70 && (
            <text x="195" y={40 + stretch * 1.1}
              fill={colors.sage}
              fontSize="13" fontWeight="700"
              fontFamily={fonts.body}>
              +$0.78
            </text>
          )}

          <text x="160" y="185" textAnchor="middle"
            fill="rgba(240,237,230,0.35)"
            fontSize="10" fontFamily={fonts.body}
            fontStyle="italic">
            {stretch > 70
              ? 'Stretched — premium worth selling'
              : stretch < 20
              ? 'At rest — watching, waiting'
              : 'Building tension'}
          </text>
        </svg>
      </div>

      {/* CREDIBILITY STRIP */}
      <div style={{
        background: colors.surface,
        borderTop: '1px solid rgba(201,168,76,0.15)',
        borderBottom: '1px solid rgba(201,168,76,0.15)',
        padding: '36px 24px'
      }}>
        <div style={{
          maxWidth: '720px',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'space-around',
          flexWrap: 'wrap',
          gap: '24px',
          textAlign: 'center'
        }}>
          <div>
            <div style={{
              fontFamily: fonts.display,
              fontSize: '34px',
              color: colors.gold
            }}>316%</div>
            <div style={{
              fontSize: '11px',
              color: 'rgba(240,237,230,0.5)',
              letterSpacing: '1px',
              textTransform: 'uppercase'
            }}>Trading account growth<br/>since May 2024</div>
          </div>
          <div>
            <div style={{
              fontFamily: fonts.display,
              fontSize: '34px',
              color: colors.sage
            }}>Real</div>
            <div style={{
              fontSize: '11px',
              color: 'rgba(240,237,230,0.5)',
              letterSpacing: '1px',
              textTransform: 'uppercase'
            }}>Trades. Real screenshots.<br/>Real outcomes — wins and losses</div>
          </div>
          <div>
            <div style={{
              fontFamily: fonts.display,
              fontSize: '34px',
              color: colors.rose
            }}>0</div>
            <div style={{
              fontSize: '11px',
              color: 'rgba(240,237,230,0.5)',
              letterSpacing: '1px',
              textTransform: 'uppercase'
            }}>Get-rich-quick<br/>promises made</div>
          </div>
        </div>
      </div>

      {/* THE DIFFERENCE */}
      <div style={{
        maxWidth: '680px',
        margin: '70px auto',
        padding: '0 24px'
      }}>
        <div style={{
          fontSize: '11px',
          color: colors.gold,
          letterSpacing: '2px',
          textTransform: 'uppercase',
          marginBottom: '14px',
          textAlign: 'center'
        }}>
          Why This Is Different
        </div>
        <div style={{
          fontFamily: fonts.display,
          fontSize: '26px',
          textAlign: 'center',
          marginBottom: '28px',
          color: colors.cream
        }}>
          Most courses teach you how to enter a trade.<br/>
          This one teaches you to read the market first.
        </div>
        <div style={{
          fontSize: '14px',
          color: 'rgba(240,237,230,0.6)',
          lineHeight: '1.9',
          textAlign: 'center',
          fontStyle: 'italic'
        }}>
          That is what happens in real life — you understand
          the market before you choose the trade. Not the
          other way around.
        </div>
      </div>

      {/* CURRICULUM JOURNEY */}
      <div style={{
        background: colors.surface,
        padding: '60px 24px'
      }}>
        <div style={{
          maxWidth: '780px',
          margin: '0 auto'
        }}>
          <div style={{
            fontSize: '11px',
            color: colors.gold,
            letterSpacing: '2px',
            textTransform: 'uppercase',
            textAlign: 'center',
            marginBottom: '8px'
          }}>
            The Foundation — Eleven Chapters
          </div>
          <div style={{
            fontFamily: fonts.display,
            fontSize: '26px',
            textAlign: 'center',
            marginBottom: '36px'
          }}>
            From "what is an option"<br/>to your first trade
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
            gap: '14px'
          }}>
            {[
              { n: '01–04', t: 'Read the Market', d: 'Price, momentum, structure — before any trade' },
              { n: '05', t: 'The Greeks', d: 'What\'s really driving an option\'s price' },
              { n: '06–08', t: 'The Strategies', d: 'CSPs, covered calls, and The Wheel' },
              { n: '09–10', t: 'Risk & Psychology', d: 'How to survive — and stay yourself' }
            ].map((item, i) => (
              <div key={i} style={{
                background: colors.bg,
                border: '1px solid rgba(201,168,76,0.15)',
                borderRadius: '10px',
                padding: '18px'
              }}>
                <div style={{
                  fontSize: '10px',
                  color: colors.gold,
                  fontFamily: 'monospace',
                  marginBottom: '8px'
                }}>{item.n}</div>
                <div style={{
                  fontFamily: fonts.display,
                  fontSize: '17px',
                  marginBottom: '6px'
                }}>{item.t}</div>
                <div style={{
                  fontSize: '12px',
                  color: 'rgba(240,237,230,0.5)',
                  lineHeight: '1.6'
                }}>{item.d}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* WHAT'S INSIDE */}
      <div style={{
        maxWidth: '780px',
        margin: '70px auto',
        padding: '0 24px'
      }}>
        <div style={{
          fontFamily: fonts.display,
          fontSize: '26px',
          textAlign: 'center',
          marginBottom: '36px'
        }}>
          What's Inside
        </div>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: '18px'
        }}>
          {[
            { icon: '◈', t: 'The Full Trade Simulator', d: 'Build real market conditions and practice every strategy before risking a dollar' },
            { icon: '◉', t: 'Weekly Live Trade', d: 'Watch Lynn enter a real position every week — and follow along on paper' },
            { icon: '🌿', t: 'Inner Work', d: 'Nervous system support for the moments trading tests you most' },
            { icon: '♀', t: 'A Real Community', d: 'Women learning together, not alone in a Discord full of strangers' }
          ].map((item, i) => (
            <div key={i} style={{
              padding: '20px',
              borderLeft: `2px solid ${colors.gold}`
            }}>
              <div style={{ fontSize: '20px', marginBottom: '8px' }}>
                {item.icon}
              </div>
              <div style={{
                fontFamily: fonts.display,
                fontSize: '17px',
                marginBottom: '6px'
              }}>{item.t}</div>
              <div style={{
                fontSize: '12px',
                color: 'rgba(240,237,230,0.5)',
                lineHeight: '1.6'
              }}>{item.d}</div>
            </div>
          ))}
        </div>
      </div>

      {/* LYNN'S VOICE */}
      <div style={{
        background: colors.surface,
        padding: '60px 24px',
        borderTop: '1px solid rgba(201,168,76,0.15)'
      }}>
        <div style={{
          maxWidth: '560px',
          margin: '0 auto',
          textAlign: 'center'
        }}>
          <div style={{ fontSize: '24px', color: colors.gold, marginBottom: '16px' }}>♀</div>
          <div style={{
            fontFamily: fonts.display,
            fontSize: '20px',
            lineHeight: '1.7',
            fontStyle: 'italic',
            color: 'rgba(240,237,230,0.85)',
            marginBottom: '16px'
          }}>
            "I built this because I needed it myself —
            and couldn't find it anywhere else.
            Not a guru. Not a guarantee.
            Just a trader, sharing exactly
            what she does, and why."
          </div>
          <div style={{
            fontSize: '12px',
            color: colors.gold,
            letterSpacing: '1px'
          }}>— Lynn</div>
        </div>
      </div>

      {/* CLOSE */}
      <div style={{
        maxWidth: '480px',
        margin: '0 auto',
        padding: '70px 24px',
        textAlign: 'center'
      }}>
        <div style={{
          fontFamily: fonts.display,
          fontSize: '22px',
          marginBottom: '14px'
        }}>
          Currently open by invitation
        </div>
        <div style={{
          fontSize: '13px',
          color: 'rgba(240,237,230,0.5)',
          lineHeight: '1.8',
          marginBottom: '28px'
        }}>
          Trade Like a Woman is in a careful beta
          stage. If you're already a member,
          log in below. If you'd like to learn
          more, reach out through the
          Facebook community.
        </div>
        <button
          onClick={onEnterLogin}
          style={{
            background: colors.gold,
            border: 'none',
            color: colors.bg,
            padding: '14px 32px',
            borderRadius: '24px',
            fontSize: '13px',
            letterSpacing: '1px',
            fontFamily: fonts.body,
            fontWeight: '600',
            cursor: 'pointer',
            textTransform: 'uppercase'
          }}>
          Member Login
        </button>
        <div style={{
          fontSize: '11px',
          color: 'rgba(240,237,230,0.3)',
          marginTop: '40px'
        }}>
          © 2026 Trade Like a Woman™ — All rights reserved
        </div>
      </div>
    </div>
  )
}
